export default __webpack_public_path__ + "static/media/Table Drill WOOSEONG.56d72308.png";